/**
 * Shopify Theme Best Practice: Wait for DOM and Shopify-specific elements
 * DOMContentLoaded ensures HTML is parsed, but Shopify sections may still be loading
 */

// Method 1: DOMContentLoaded - Basic DOM ready
window.addEventListener("DOMContentLoaded", () => {
  console.log("DOM Content Loaded");
  initializeScrollHandlers();
});

// Initialize scroll handlers
function initializeScrollHandlers() {
  // Wait for specific elements that might be loaded dynamically

  // document.querySelector("#HeaderMenu-the-collection").addEventListener("click", function (e) {
  //   //if we are not on the home page, do not scroll
  //   if (window.location.pathname !== "/") {
  //     // goto to home page
  //     window.location.href = "/";
  //     return;
  //   }
  //   e.preventDefault();
  //   const targetId = "__rich_text_7aWmib";
  //     // get the header height (<sticky-header>)
  //   const headerHeight = document.querySelector("sticky-header").offsetHeight;
  //   scrollToElement(targetId, headerHeight);
  // });

  document.querySelector("#HeaderDrawer-the-collection").addEventListener("click", function (e) {
    //if we are not on the home page, do not scroll
    if (window.location.pathname !== "/") {
      // goto to home page
      window.location.href = "/";
      return;
    }
    e.preventDefault();
    const targetId ="__rich_text_7aWmib";
    document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
    document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
    document.querySelector("#Details-menu-drawer-container .header__icon").setAttribute("aria-expanded", "false");
    document.querySelector(".shopify-section-header-sticky").classList.remove("menu-open");
    document.body.classList.remove("overflow-hidden-tablet");
    
    // get the header height (<sticky-header>)
    const headerHeight = document.querySelector("sticky-header").offsetHeight;
    scrollToElement(targetId, headerHeight);
  });
}

// Scroll utility function
function scrollToElement(elementId, offset = 0) {
  console.log("Scrolling to element containing:", elementId);
  
  // First try exact match
  let element = document.getElementById(elementId);
  
  // If no exact match, look for section with ID containing the elementId
  if (!element) {
    element = document.querySelector(`section[id*="${elementId}"]`);
    console.log("Looking for section containing:", elementId, "Found:", element);
  }
  
  // If still no match, try any element with ID containing the elementId
  if (!element) {
    element = document.querySelector(`[id*="${elementId}"]`);
    console.log("Looking for any element containing:", elementId, "Found:", element);
  }
  
  if (element) {
    console.log("Found element:", element.id);
    const rect = element.getBoundingClientRect();
    const scrollPosition = rect.top + window.scrollY - offset;

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  } else {
    console.error("Element not found containing:", elementId);
    // Debug: show all elements with similar IDs
    const similarElements = document.querySelectorAll('[id*="rich_text"]');
    console.log("Available elements with 'rich_text':", Array.from(similarElements).map(el => el.id));
  }
}
